import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import startProtectionbg from "../../Assets/images/startprotection.jpg";
import { useTranslation } from "react-i18next";
import { ApplicationState } from "../../../store";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";

const StartProtection = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);


    const query = new URLSearchParams(props.location.search);
    let code: any = query.get("Accesscode");
    code = code?.includes(" ") ? code.replace(/\s/g, "+") : code;

    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            offercode: code ? code : "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [showMaxAttemptErrorMsg, setShowMaxAttemptErrorMsg] = useState(false);
    const [state, setState] = useState({
        offercode: "",
        showErrorMessage: false,
        errorMsg: "offercode Code is Required",
        isLoading: false,
    });
    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value === "checkbox" ? target.checked : target.value;
        const name = target.name;

        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

useEffect(() => {
        if (code != "" && code != null) {
            const data = {
                offercode: code
            };
            onSubmit(data);
        }
    }, [code])

    const checkRetailerExists = async(retailerCode: string) => {
        let isRetailerExists = false;
        const requestBody = {
            RetailerCode: retailerCode
        }
               await httpClient
                .sendRequest("POST", `api/PartnerService/getRetailerDetails`, requestBody)
                .then((data) => {
                    if (!data["hasError"] && data["retailerCode"] !== null) {
                        if (data["retailerCode"].toLowerCase() === retailerCode.toLowerCase()) {
                            isRetailerExists = true;
                        }
                    }
                })
                .catch((error) => {
                    isRetailerExists = false;
                });
        return isRetailerExists;
    };

    const onSubmit = (data: any) => {
        setShowAccessCodeField(false);
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            provisionalID: data.offercode,
            partnerID: partnerID,
        };

        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage3?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding?.[0]?.statusCode && data.provisionalResponseLanding?.[0]?.statusCode === '5051') {
                    setShowMaxAttemptErrorMsg(true);
                    setState({ ...state, showErrorMessage: false, errorMsg: "offercode Code is Required", isLoading: false, offercode: "" });
                }
                else if (data.provisionalResponseLanding.length === 0 || !data.provisionalResponseLanding?.[0]?.provisionalID) {
                    setShowAccessCodeField(true);
                    setState({ ...state, showErrorMessage: false, errorMsg: "offercode Code is Required", isLoading: false, offercode: "" });
                } else {
                    if (data.provisionalResponseLanding.length !== 0 && data.provisionalResponseLanding[0].provisionalID.trim() === requestBody.provisionalID.trim()) {
                        props.history.push({
                            pathname:
                                "/Register?Type=" +
                                data.provisionalResponseLanding[0].contractStatus +
                                "&VALUE=" +
                                data.provisionalResponseLanding[0].provisionalID +
                                "&GNDNRLL=PSS",
                        });
                        window.location.reload();
                    } else {
                        const requestBodyAccessCode = {
                            accessCode: state.offercode
                        };
                        httpClient
                            .sendRequest("POST", `api/PartnerService/GetRetailerCodeByAccessCode`, requestBodyAccessCode)
                            .then(async(retailerdata) => {
                                if (!retailerdata["HasError"] && retailerdata["cgW_RetailerCode"] !== null) {
                                    const isRetailerExists = checkRetailerExists(retailerdata["cgW_RetailerCode"]);
                                    if (await isRetailerExists) {
                                        props.history.push({
                                            pathname:
                                                "/Register?Type=" +
                                                data.provisionalResponseLanding[0].contractStatus +
                                                "&VALUE=" +
                                                data.provisionalResponseLanding[0].provisionalID +
                                                "&GNDNRLL=GBPSS" +
                                                "&RETAILERCODE=" +
                                                retailerdata["cgW_RetailerCode"],

                                        });
                                    } else {
                                        props.history.push({
                                            pathname:
                                                "/Register?Type=" +
                                                data.provisionalResponseLanding[0].contractStatus +
                                                "&VALUE=" +
                                                data.provisionalResponseLanding[0].provisionalID +
                                                "&GNDNRLL=GBPSS",
                                        });
                                    }
                                                                   
                                } else {
                                    props.history.push({
                                        pathname:
                                            "/Register?Type=" +
                                            data.provisionalResponseLanding[0].contractStatus +
                                            "&VALUE=" +
                                            data.provisionalResponseLanding[0].provisionalID +
                                            "&GNDNRLL=GBPSS",
                                    });
                                }
                                window.location.reload();
                            })
                            .catch(function (error) {
                                setValue("offercode", null);
                                reset();
                                trigger();
                                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, offercode: "" });
                            });
                    }                  
                }
            })
            .catch(function (error) {
                setValue("offercode", null);
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, offercode: "" });
            });
    };

    return (
        <React.Fragment>
            {showAccessCodeField ? (
                <PSSBannerMessage layout={"psslandingstartprotection"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
            ) : errors.offercode ? (
                    <PSSBannerMessage layout={"psslandingstartprotectionerrormsg"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                ) : showMaxAttemptErrorMsg ? (<PSSBannerMessage layout={"psslandingmaxattempterror"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />)
                : <></>}

            <main is="x3d" id="l-page-content main-content">
                <div>
                    <div
                        style={{
                            backgroundImage: `url(${startProtectionbg})`,
                        }}
                        className="start-protection-img"
                    > 
                        <div className="start-protection-container">
                            <div className="hero">
                                <h1>Never Face Identity Crime Alone</h1>
                                <h2>Register your ID Crime Protection Services</h2>
                                <form id="form-member-login" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="action-block">
                                        <div className="insert-form pss-startprotection">
                                            <div className="form">
                                                <label className="hide-label" htmlFor="offercode">Enter your Offer Code</label>
                                                <input
                                                    className="form-input"
                                                    placeholder="Enter Code"
                                                    aria-required="true"
                                                    id="offercode"
                                                    name="offercode"
                                                    onChange={handleInputChange}
                                                    ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })}
                                                />

                                                {errors.offercode && errors.offercode.type === "required" && !state.showErrorMessage && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">Please enter a valid code to continue</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <input type="submit" onClick={() => handleSubmit(onSubmit)} className="start-protection-button" value="Get started" />
                                        </div>
                                        <div className="pssLoginLinkContainer">
                                            Already have an account? <a href="/app/login">Login</a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>                   
                </div>
            </main>
        </React.Fragment>
    );
};
export default StartProtection;
